// src/rds_ui/api/jiraApi.js
//
// Migrated off raw fetch() onto the shared axios instance in
// src/api/client.js (see projectsApi.js in this folder for why). Error
// detail extraction now goes through getApiError() instead of a manual
// `(await r.json()).detail` read.
import { api, getApiError } from "../../api/client";

const BASE = "/rds";

export async function saveJiraConfig(projectId, config) {
  try {
    const res = await api.post(`${BASE}/projects/${projectId}/jira/config`, config);
    return res.data;
  } catch (e) {
    throw new Error(getApiError(e) || "Failed to save Jira config");
  }
}

export async function testJiraConnection(projectId) {
  try {
    const res = await api.post(`${BASE}/projects/${projectId}/jira/test`);
    return res.data;
  } catch (e) {
    throw new Error(getApiError(e) || "Connection failed");
  }
}

export async function pushToJira(projectId, payload) {
  try {
    const res = await api.post(`${BASE}/projects/${projectId}/jira/push`, payload);
    return res.data;
  } catch (e) {
    throw new Error(getApiError(e) || "Push failed");
  }
}

export async function fetchJiraConfig(projectId) {
  try {
    const res = await api.get(`${BASE}/projects/${projectId}/jira/config`);
    return res.data;
  } catch {
    throw new Error("Failed to fetch Jira config");
  }
}

export async function fetchJiraPushStatus(projectId, generationRunId) {
  try {
    const res = await api.get(`${BASE}/projects/${projectId}/jira/status`, {
      params: { generation_run_id: generationRunId },
    });
    return res.data;
  } catch {
    throw new Error("Failed to fetch Jira status");
  }
}
